import { SVGComponentProps } from "untitledui-js-base";

export const MenuRow = ({
  Icon,
  text,
  isDisabled = false
}: {
  text: string;
  isDisabled?: boolean;
  Icon: React.FC<SVGComponentProps>;
}) => {
  return (
    <span className="flex gap-2 items-center">
      <Icon
        size="20"
        className={isDisabled ? "stroke-content-100" : "stroke-content-200"}
      />
      <p className={isDisabled ? "text-content-100" : "text-content-1000"}>
        {text}
      </p>
    </span>
  );
};
